export const FAQS = [
  {
    q: "Do you come to my house?",
    a: "Yes — that's the whole point. We perform brake replacements at your home, workplace or anywhere your car is safely parked across Middlesex County, MA and Southern NH.",
  },
  {
    q: "Can you replace brakes in my driveway?",
    a: "Absolutely. A reasonably flat, firm surface with room to work around the vehicle is all we need. Driveways, office lots and apartment lots all work.",
  },
  {
    q: "How much does mobile brake replacement cost?",
    a: "It depends on your vehicle and whether you need front, rear or both axles. Request a quote with your year, make and model and you'll get an exact, transparent price — no surprises, no shop markups.",
  },
  {
    q: "Do you replace brake pads and rotors?",
    a: "Yes. Most jobs include new pads and rotors together, which is the correct way to restore safe, quiet braking. We measure your rotors on site and only replace what actually needs replacing.",
  },
  {
    q: "Can you replace front and rear brakes?",
    a: "Yes — front, rear or both axles in a single visit. Doing both at once usually takes about two hours and is the most cost-effective option.",
  },
  {
    q: "What areas do you service?",
    a: "Middlesex County, Massachusetts and Southern New Hampshire — including Dracut, Lowell, Chelmsford, Tyngsboro, Billerica, Nashua, Hudson and Pelham, plus surrounding towns.",
  },
  {
    q: "Do I need to provide the parts?",
    a: "No. We supply quality brake pads, rotors and hardware matched to your exact vehicle. Parts are included in your quote and covered by our warranty.",
  },
  {
    q: "Do your repairs include a warranty?",
    a: "Yes. Every brake job is warranty-backed on parts and labor, in writing. If something we installed fails under normal use, we come back and make it right.",
  },
  {
    q: "How long does brake replacement take?",
    a: "A typical front or rear brake job takes about 60–90 minutes. Both axles usually run around two hours — and you spend that time in your own home, not a waiting room.",
  },
  {
    q: "How do I schedule my brake replacement?",
    a: "Just call or text (978) 967-9860. You'll get a straight answer on price and we'll lock in a day and time — most jobs are scheduled within days, Monday through Saturday.",
  },
  {
    q: "Do I have to pay before the appointment?",
    a: "No payment is due today. You approve an exact quote before work begins and pay when the job is done. Online deposit and pre-payment options are coming soon.",
  },
];
